module.exports = __webpack_public_path__ + "media/packs/src/assets/images/payment-3bb955923ad11178cb5666f5d07a5b27.png";